/* eslint-disable import/prefer-default-export */
/* eslint-disable camelcase */
import {
    ARCHITECTURE_1oo1,
    ARCHITECTURE_1oo2,
    ARCHITECTURE_1oo2D,
    ARCHITECTURE_1oo3,
    ARCHITECTURE_2oo2,
    ARCHITECTURE_2oo3,
    ARCHITECTURE_2oo4,
    ARCHITECTURE_3oo3,
} from "const"
import { SilArchitecture } from "client/utils"


// used both for PFD and PFH
interface PfdFailureRateFalse {
    architecture: SilArchitecture
    pfd: number
    beta: number
}

// "**" (double "*") is an equivalent of "Math.pow"
export const pfdFailureRateFalse = ({
    architecture,
    pfd,
    beta,
}: PfdFailureRateFalse) => {
    if (architecture === ARCHITECTURE_1oo1) {
        return pfd
    }

    if (architecture === ARCHITECTURE_1oo2 || architecture === ARCHITECTURE_1oo2D) {
        return (4 / 3) * (pfd ** 2) + beta * pfd
    }

    if (architecture === ARCHITECTURE_1oo3) {
        return 2 * (pfd ** 3) + 0.5 * beta * pfd
    }

    if (architecture === ARCHITECTURE_2oo2) {
        return 2 * pfd
    }

    if (architecture === ARCHITECTURE_2oo3) {
        return 4 * (pfd ** 2) + 1.5 * beta * pfd
    }

    if (architecture === ARCHITECTURE_2oo4) {
        return 6 * (pfd ** 3) + 2 * beta * pfd
    }

    if (architecture === ARCHITECTURE_3oo3) {
        return 3 * pfd
    }

    return null
}
